import { render, staticRenderFns } from "./MergeOrder.vue?vue&type=template&id=70e78196&scoped=true"
import script from "./MergeOrder.vue?vue&type=script&lang=js"
export * from "./MergeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e78196",
  null
  
)

export default component.exports